import { useTeleconsultingContext } from 'contexts/TeleconsultingContext';
import React, { useState } from 'react';

import { MeetingsTab } from '../MeetingsTab';
import './TeleconsultingTab.css';

export function TeleconsultingTab() {
  const [teleconsultingScheduled, setTeleconsultingScheduled] = useState(true);
  const { appointment } = useTeleconsultingContext();
  const actualDateTime = new Date(Date.now()).toISOString();
  // const actualDateTime = new Date('2022-11-21T16:45:45.000-03:00').toISOString();
  const booked =
    appointment?.entry?.filter(
      (element) => new Date(actualDateTime) < new Date(element.resource.end),
    ) || [];
  const finished =
    appointment?.entry?.filter(
      (element) => new Date(actualDateTime) > new Date(element.resource.end),
    ) || [];

  function converterData(dataStr) {
    return new Date(dataStr);
  }
  return (
    <div className="TeleconsultingArea">
      <div className="TeleconsultingArea-tabs">
        <button
          className={
            teleconsultingScheduled
              ? 'TeleconsultingArea-openTab'
              : 'TeleconsultingArea-tabs button'
          }
          onClick={() => setTeleconsultingScheduled(true)}
        >
          Agendados
        </button>
        <button
          className={
            !teleconsultingScheduled
              ? 'TeleconsultingArea-openTab'
              : 'TeleconsultingArea-tabs button'
          }
          onClick={() => setTeleconsultingScheduled(false)}
        >
          Passados
        </button>
      </div>

      <MeetingsTab
        data={
          teleconsultingScheduled
            ? booked
            : finished?.sort(
                (a, b) =>
                  converterData(b?.resource?.end) -
                  converterData(a?.resource?.end),
              )
        }
        hasAccess={teleconsultingScheduled}
      />
    </div>
  );
}
